// extracted by mini-css-extract-plugin
export default {"melodyVideo":"RJ-z","isFullWidth":"SJ-z","landingPageVideo":"TJ-z","play":"UJ-z","iframeVideo":"VJ-z","playHidden":"WJ-z","fullwidth":"XJ-z"};